import { createAsyncThunk } from '@reduxjs/toolkit'
import RawMetric from './raw-metric-model'
import {
  delete_rawMetric,
  load_rawMetrics,
  store_rawMetric,
} from './rawMetric-service'

export const LoadRawMetricsAsync = createAsyncThunk<any, any>(
  'composer/load/rawMetric',
  async (params: { uid: string }) => {
    return await load_rawMetrics(params)
  },
)

export const CreateRawMetricAsync = createAsyncThunk<any, any>(
  'composer/create/rawMetric',
  async (params: RawMetric) => {
    return await store_rawMetric(params)
  },
)

export const DeleteRawMetricAsync = createAsyncThunk<any, any>(
  'composer/delete/rawMetric',
  async (params) => {
    return await delete_rawMetric(params)
  },
)
